import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'building_guid': 'String',
	'floor_guid': 'String',
	'room_guid': 'String',
	'team_guid': '[String]',
};

export default gql( `
	mutation team_building_rights( ${ HelperGraphql.createFields( fields ) } ) {
	    team_building_rights( ${ HelperGraphql.createVariables( fields ) } ) {
	       updated_at
	    }
	}
` );

